import { Dialog } from "@mui/material";
import { X } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useEffect, useRef, useState } from "react";
import API from "../../API/newIndex";
import ImageUploader from "../../controllers/ImageUploader";
import { Transition } from "../../controllers/Transition";
import {
  ButtonComponent,
  InputComponent,
  SelectComponent
} from "@shopeasy-dashboard-ui/ui-library";
import TextareaComponent from "../FormInput/TextareaComponent";
import Notification from "../Notification";
const AddBlogComments = ({ commentRef, isAddComment, closeAddComment, type, editCommentData }) => {
  const localRef = useRef(null);
  const resolvedRef = commentRef || localRef;
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };
  const [commentData, setCommentData] = useState({
    name: "",
    profile_picture: "",
    comment: "",
    blogId: "",
  });


  useEffect(() => {
    if (editCommentData) {
      setCommentData({
        name: editCommentData?.name,
        profile_picture: editCommentData?.profile_picture,
        comment: editCommentData?.comment,
        blogId: editCommentData?.blogId?._id,
      });
    }
  }, [editCommentData]);
  // image upload logic
  const handleSetImage = (value) => {
    setCommentData({ ...commentData, profile_picture: value });
  };
  // get all blogs
  const [allBlogs, setAllBlogs] = useState([]);
  const GetBlogs = async (searchKey = "") => {
    try {
      const url = `/admin/blog/getBlogs?is_draft=false${searchKey ? `&searchkey=${searchKey}` : ""
        }`;
      const data = await API({ url: url, method: "get" });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        setAllBlogs(result?.data?.records);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };
  const [autocompleteSearch, setAutocompleteSearch] = useState();
  useEffect(() => {
    if (!isAddComment) return;
    const handler = setTimeout(() => {
      if (autocompleteSearch && autocompleteSearch.length >= 3) {
        const hasData = allBlogs?.some((option) => {
          return option?.title?.toLowerCase().includes(autocompleteSearch.toLowerCase());
        });
        if (!hasData) {
          GetBlogs(autocompleteSearch);
        }
      } else {
        GetBlogs();
      }
    }, 500);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autocompleteSearch, isAddComment]);
  const handleAddBlogComment = async (e) => {
    e.preventDefault();
    const payload = commentData;
    if (type === "edit") {
      try {
        await API({
          url: `/admin/blog/updateBlogcomments/${editCommentData?._id}`,
          method: "put",
          data: payload,
        });
        closeAddComment("call api");
        setIsNotification(true);
        setNotificationMsg("Blog comment updated successfully");
        setSeverity("success");
        setCommentData({
          name: "",
          profile_picture: "",
          comment: "",
          blogId: "",
        });
      } catch (error) {
        setIsNotification(true);
        setNotificationMsg(error);
        setSeverity("error");
      }
    } else {
      try {
        await API({
          url: `/admin/blog/AddAdminComment`,
          method: "post",
          data: payload,
        });
        closeAddComment("call api");
        setCommentData({
          name: "",
          profile_picture: "",
          comment: "",
          blogId: "",
        });
      } catch (error) {
        setIsNotification(true);
        setNotificationMsg(error);
        setSeverity("error");
      }
    }
  };
  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <Dialog
        open={isAddComment}
        TransitionComponent={Transition}
        TransitionProps={{
          onEntered: () => {
            resolvedRef.current?.focus();
          },
        }}
        onClose={() => {
          closeAddComment();
          setCommentData({
            name: "",
            profile_picture: "",
            comment: "",
            blogId: "",
          });
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="h-auto secondary-bg-color overflow-y-auto p-5">
          <div className="flex items-end justify-between w-full overflow-auto">
            <h4 className="text-xl md:text-2xl font-semibold text-primary">{`${type === "edit" ? "Update" : "Add"
              } Blog comment`}</h4>
            <button
              type="button"
              className="close-btn"
              onClick={(e) => {
                e.preventDefault();
                closeAddComment();
                setCommentData({
                  name: "",
                  profile_picture: "",
                  comment: "",
                  blogId: "",
                });
              }}
            >
              <X className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>
          <hr className="my-4 main-border-color" />
          <div className="flex flex-col sm:flex-row w-full sm:w-[550px] justify-evenly mx-auto">
            <form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              method="POST"
              className="space-y-4 w-full mx-auto"
            >
              <div className="group space-y-4">
                {type === "add" && (
                  <div className="w-full">
                    <label htmlFor="title" className="capitalize">
                      {t("lang_name")}
                      <span className="text-red-500 ms-1">*</span>
                    </label>
                    <InputComponent
                      type="text"
                      name="title"
                      ref={resolvedRef}
                      value={commentData?.name}
                      onChange={(e) => setCommentData({ ...commentData, name: e.target.value })}
                      placeholder="e.g. John"
                      autoFocus={true}
                    />
                  </div>
                )}
                {type === "add" && (
                  <div className="w-full mb-4">
                    <label htmlFor="title">{t("lang_Profile_Picture")}</label>
                    <ImageUploader
                      alreadyImage={commentData?.profile_picture}
                      handleSetImage={handleSetImage}
                      folder="profile"
                      format="image"
                    />
                  </div>
                )}
                <div className="w-full">
                  <TextareaComponent
                    id="title"
                    name="title"
                    ref={type === "edit" ? resolvedRef : undefined}
                    label={t("lang_comment")}
                    required={true}
                    value={commentData?.comment}
                    onChange={(e) =>
                      setCommentData({
                        ...commentData,
                        comment: e.target.value,
                      })
                    }
                    placeholder="Enter your comment here..."
                    rows={3}
                    autoFocus={type === "edit"}
                  />
                </div>
                {type === "add" && (
                  <div className="mb-4">
                    <label htmlFor="description">
                      {t("lang_Select_Blog")}
                      <span className="text-red-500 ms-1">*</span>
                    </label>
                    <SelectComponent
                      placeholder="Select blog"
                      value={commentData?.blogId || ""}
                      onChange={(e, v) => {
                        const val = e?.target?.value !== undefined ? e.target.value : (typeof v === "object" && v !== null ? (v.value || v._id) : (v || ""));
                        setCommentData({ ...commentData, blogId: val });
                      }}
                      options={allBlogs ? allBlogs.map(blog => ({ value: blog._id, label: blog.title })) : []}
                      onInputChange={(inputValue) => {
                        if (inputValue && inputValue.length >= 3) {
                          setAutocompleteSearch(inputValue);
                        } else {
                          setAutocompleteSearch();
                        }
                      }}
                      required
                    />
                  </div>
                )}
                {commentData?.name === "" ||
                  commentData?.blogId === "" ||
                  commentData?.comment === "" ? (
                  <div className="w-full flex justify-end">
                    <ButtonComponent
                      variant="primary"
                      disabled
                      type="button"
                    >
                      {type === "add" ? "Add Blog Comment" : "Update Blog Comment"}
                    </ButtonComponent>
                  </div>
                ) : (
                  <div className="w-full flex justify-end">
                    <ButtonComponent
                      variant="primary"
                      type="button"
                      onClick={(e) => handleAddBlogComment(e)}
                    >
                      {type === "add" ? "Add Blog Comment" : "Update Blog Comment"}
                    </ButtonComponent>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default AddBlogComments;
